var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.041 0c-9.76 1.84-16.8 10.48-16.64 20.48v901.12c0 11.277 9.2 20.48 20.48 20.48h61.44v61.44c0 11.277 9.2 20.48 20.48 20.48h696.321c11.277 0 20.48-9.203 20.48-20.48v-901.12c0-11.28-9.203-20.48-20.48-20.48h-61.44v-61.44c0-11.28-9.203-20.48-20.48-20.48h-700.161zM143.361 40.96h655.361v860.16h-655.361v-860.16zM880.642 122.88v860.16h-655.361v-40.96h593.921c11.277 0 20.48-9.203 20.48-20.48v-798.72h40.96zM474.881 215.040c79.84 0 133.12 51.040 133.12 124.8 0 34.8-11.92 61.84-36.48 96.64l-49.28 67.2c-14.32 20.48-18.56 31.12-18.56 55.68v22.4c0 4.080-2.16 8.32-8.32 8.32h-48.64c-2.080 0-6.4-4.24-6.4-8.32v-30.72c0-28.64 6-45.44 22.4-65.92l49.28-67.2c26.64-34.8 34.56-51.44 34.56-78.080 0-40.96-28.64-67.2-71.68-67.2-40.96 0-67.36 24.080-75.52 69.12 0 4.080-4.24 6.4-8.32 6.4l-46.72-8.32c-4.080 0-6.4-4.24-6.4-8.32 10.24-69.6 61.2-116.48 136.96-116.48zM438.401 653.44v63.36c0 6.157 4.24 8.32 8.32 8.32h55.040c6.16 0 8.32-4.237 8.32-8.32v-63.36c0-6.157-4.24-8.32-8.32-8.32h-55.040c-6.16 0-8.32 4.237-8.32 8.32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestions);
export default __webpack_public_path__ + "static/media/questions.42d71f495c206a88f2b8081648ec6224.svg";
export { ForwardRef as ReactComponent };